import { createSvg } from '@r1-frontend/ui-kit/atoms/svg/createSvg';

const ArrowUp = ({ strokeWidth = 1.5 }: { strokeWidth?: number }): JSX.Element => {
    return (
        <g id={'guts'}>
            <path
                d='M19.9201 15.05L13.4001 8.53C12.6301 7.76 11.3701 7.76 10.6001 8.53L4.08008 15.05'
                strokeWidth={strokeWidth}
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </g>
    );
};

export default createSvg(ArrowUp, 'arrow-up');
